// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 22:02:11

export default {
  "id": "doodle-football",
  "slug": "doodle-football",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/2babe9f2198b4ac38944b8f4c81fff7c-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/2babe9f2198b4ac38944b8f4c81fff7c/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Doodle Football",
      "description": "Doodle Football is an imaginative and captivating 2D casual game that combines creativity, strategy, and fun. Your goal is simple: guide the football into the goal while overcoming exciting challenges across a variety of themes like the lush greenery of fields, the scorching sands of the desert, and the frosty landscapes of ice. ",
      "instructions": "Left mouse button to draw a line.\nRestart button or R to restart.\nStart button or Space to start.\n[Use Landscape mode for Mobile devices]",
      "genres": [
        "Casual",
        "Football"
      ],
      "tags": [
        "1player",
        "ball",
        "drawing",
        "highscore"
      ]
    },
    "zh-CN": {
      "title": "涂鸦足球",
      "description": "涂鸦足球是一款充满想象力和吸引力的2D休闲游戏，结合了创造力、策略和乐趣。你的目标很简单：引导足球进入球门，同时克服各种主题下的激动人心的挑战，如郁郁葱葱的草地、炽热的沙漠沙丘和冰冷的雪地景观。",
      "instructions": "左鼠标按钮用于画线。\n重置按钮或按R键重启。\n开始按钮或按空格键开始。\n[在移动设备上使用横幅模式]",
      "genres": [
        "休闲",
        "足球"
      ],
      "tags": [
        "1玩家",
        "球",
        "绘制",
        "高分"
      ]
    },
    "zh-TW": {
      "title": "塗鴉足球",
      "description": "塗鴉足球是一款富創意且引人入勝的2D休閒遊戲，結合創意、策略與樂趣。你的目標簡單：引導足球進入球門，並克服各種主題的挑戰，如綠意盎然的草地球場、炎熱的沙漠沙灘，以及寒冷的冰地景觀。",
      "instructions": "左鍵繪製線條。\n重新開始按鈕或按R重新開始。\n開始按鈕或按空格開始。\n[手機設備請使用橫向模式]",
      "genres": [
        "休闲",
        "足球"
      ],
      "tags": [
        "1玩家",
        "球",
        "繪製",
        "最高分"
      ]
    },
    "zh-HK": {
      "title": "塗鴉足球",
      "description": "塗鴉足球是一款富創意且吸引人的2D休閒遊戲，結合了創意、策略及樂趣。你的目標簡單：引導足球進入球門，並克服各種主題的挑戰，如綠意盎然的草地、炙熱的沙漠沙灘，以及冰冷的冰地景觀。",
      "instructions": "左鍵繪製線條。\n重新開始按鈕或按 R 鍵重新開始。\n開始按鈕或按空格鍵開始。\n[使用橫向模式適用於手機裝置]",
      "genres": [
        "隨意足球"
      ],
      "tags": [
        "1玩家",
        "球",
        "繪圖",
        "高分"
      ]
    },
    "ja": {
      "title": "ドoodleフットボール",
      "description": "ドoodle Footballは、創造性、戦略性、そして楽しさを融合した魅力的な2Dカジュアルゲームです。あなたの目標はシンプルです：ゴールにサッカーを導き、緑豊かなグラウンド、灼熱の砂漠、そして冷たい氷の地などの様々なテーマの挑戦を乗り越えることです。",
      "instructions": "左クリックボタンで線を描きます。\nリスタートボタンまたはRキーでリスタート。\nスタートボタンまたはスペースキーで開始。\n[モバイル端末にはランドスケープモードを使用してください]",
      "genres": [
        "カジュアル",
        "フットボール"
      ],
      "tags": [
        "1プレイヤー",
        "ボール",
        "絵描き",
        "ハイスコア"
      ]
    },
    "ko": {
      "title": "도도 foot볼",
      "description": "도들 풋볼은 창의적이고 매력적인 2D 캐주얼 게임으로, 창의성, 전략, 즐거움을 결합한 게임입니다. 목표는 간단합니다: 축구공을 골에 넣으며 다양한 주제와의 흥미로운 도전을 극복합니다. 그 주제들은 초록빛이 짙은 경기장, 더위가 뜨거운 사막, 얼음이 내리는 풍경 등입니다.",
      "instructions": "왼쪽 마우스 버튼으로 선을 그리세요.\n재시작 버튼이나 R 키를 눌러 재시작하세요.\n시작 버튼이나 공백 키를 눌러 시작하세요.\n[모바일 기기에서는 랜드스케이프 모드 사용하세요]",
      "genres": [
        "캐주얼",
        "축구"
      ],
      "tags": [
        "1플레이어",
        "볼",
        "드로잉",
        "하이스코어"
      ]
    },
    "fr": {
      "title": "Footballez des Doodle",
      "description": "Doodle Football est un jeu casual 2D imaginatif et captivant qui combine créativité, stratégie et amusement. Votre objectif est simple : guidez le ballon de football dans le but tout en surmontant des défis captivants dans divers thèmes comme les champs verdoyants, les sables brûlants du désert et les paysages gelés.",
      "instructions": "Bouton gauche de la souris pour dessiner une ligne.\nBouton de redémarrage ou R pour redémarrer.\nBouton de démarrage ou Espace pour commencer.\n[Utilisez le mode paysage pour les appareils mobiles]",
      "genres": [
        "Facile",
        "Football"
      ],
      "tags": [
        "1 joueur",
        "balle",
        "dessin",
        "record haut"
      ]
    }
  }
};
